<div class="flex items-center py-1 select-none group relative">

  <!-- Fleche d'expansion -->
  <button *ngIf="node && node.children && node.children.length > 0" (click)="toggleExpand()"
    class="w-5 h-5 mr-1 focus:outline-none">
    <svg class="w-4 h-4 text-gray-600 transition-transform duration-200" [class.rotate-90]="node.expanded"
      viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd"
        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
        clip-rule="evenodd" />
    </svg>
  </button>
  <div *ngIf="!node || !node.children || node.children.length === 0" class="w-5 mr-1"></div>
  <app-tooltip [text]="getTooltipText(node)" position="left">
    <div class="flex items-center">
      <!-- Checkbox personnalise -->
      <div (click)="toggleCheckbox($event)"
        class="relative w-6 h-6 mr-3 cursor-pointer flex items-center justify-center rounded border-2 transition-all duration-200"
        [class.border-green-600]="node?.state === 'selected'" [class.bg-green-600]="node?.state === 'selected'"
        [class.border-4]="node?.state === 'selected'" [class.border-blue-300]="node?.state === 'partial-select'"
        [class.bg-blue-100]="node?.state === 'partial-select'" [class.border-red-700]="node?.state === 'not-selected'"
        [class.bg-red-700]="node?.state === 'not-selected'">

        <!-- Check-mark pour selected -->
        <svg *ngIf="node?.state === 'selected'" class="w-5 h-5 text-white pointer-events-none" viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd" />
        </svg>

        <!-- Petit carre bleu pour partial-select -->
        <div *ngIf="node?.state === 'partial-select'" class="w-3 h-3 bg-blue-700 rounded pointer-events-none"></div>

        <!-- X blanc pour not-selected -->
        <svg *ngIf="node?.state === 'not-selected'" class="w-5 h-5 text-white pointer-events-none" viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd" />
        </svg>
      </div>

      <!-- Label cliquable -->
      <span (click)="selectNode()" class="cursor-pointer text-gray-800 hover:text-gray-900">
        {{ nodeValue | translate }}
      </span>
    </div>
  </app-tooltip>

</div>

<!-- Enfants -->
<div *ngIf="node && node.expanded && node.children && node.children.length > 0" class="ml-6 border-l border-gray-300">
  <app-tree-node *ngFor="let child of node.children" [node]="child" (selectionChange)="onChildChange()">
  </app-tree-node>
</div>
